

import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Fade, Slide } from "react-awesome-reveal";
import { sendContactMessage } from "../services/apiService"; // ✅ Import your API function

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    captcha: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    // ✅ Basic validation
    if (!formData.name || !formData.email || !formData.phone || !formData.message) {
      setError("All fields are required");
      setLoading(false);
      return;
    }

    try {
      const res = await sendContactMessage(formData);
      setSuccess("Message sent successfully!");
      setFormData({ name: "", email: "", phone: "", message: "", captcha: "" });
    } catch (err) {
      setError(err.message || "Failed to send message");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="py-5" style={{ backgroundColor: "transparent", textAlign: "center" }}>
      <div className="container">
        {/* 🔹 Section Title */}
        <Fade triggerOnce>
          <h2
            className="fw-bold mb-5"
            style={{
              color: "#00BFFF",
              backgroundColor: "rgba(0,191,255,0.1)",
              display: "inline-block",
              padding: "10px 25px",
              borderRadius: "50px",
              fontSize: "1.8rem",
            }}
          >
            CONTACT US
          </h2>
        </Fade>

        {/* 🔹 Contact Info */}
        <div className="row justify-content-center mb-5">
          {[
            { icon: "📍", title: "Our Address", text: "Amarnagar faridabad haryana - 121003" },
            { icon: "✉️", title: "Email Us", text: "Info@smigc.in" },
            { icon: "📞", title: "Call Us", text: "8982261363" },
          ].map((item, i) => (
            <div key={i} className="col-md-4 col-sm-6 mb-4">
              <Fade direction="up" triggerOnce delay={i * 150}>
                <div className="d-flex flex-column align-items-center p-3">
                  <div style={{ fontSize: "2.5rem", color: "#00BFFF", marginBottom: "10px" }}>
                    {item.icon}
                  </div>
                  <h5 className="fw-bold mb-2">{item.title}</h5>
                  <p style={{ color: "#555", fontSize: "0.95rem" }}>{item.text}</p>
                </div>
              </Fade>
            </div>
          ))}
        </div>

        {/* 🔹 Map and Form */}
        <div className="row justify-content-center align-items-start">
          {/* <div className="col-md-6 mb-4">
            <Slide direction="left" triggerOnce>
              <iframe
                title="map"
                src="https://www.google.com/maps?q=Bhopal,Madhya+Pradesh&output=embed"
                width="100%"
                height="325"
                style={{ border: "0", borderRadius: "10px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </Slide>
          </div> */}

    <div className="col-md-10 col-lg-8" style={{ height: "300px" }}>
            <Slide direction="right" triggerOnce>
              <form
                className="p-4 bg-white rounded shadow-sm d-flex flex-column"
                style={{ textAlign: "left", height: "100%", justifyContent: "space-between" }}
                onSubmit={handleSubmit}
              >
                <div className="row mb-3">
                  <div className="col">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Your Name *"
                      className="form-control"
                      required
                    />
                  </div>
                  <div className="col">
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Your Email *"
                      className="form-control"
                      required
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <input
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Phone *"
                    className="form-control"
                    required
                  />
                </div>
                <div className="mb-3 flex-grow-1">
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Message *"
                    className="form-control"
                    rows="4"
                    style={{ height: "100%", resize: "none" }}
                    required
                  ></textarea>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <input
                    type="text"
                    name="captcha"
                    value={formData.captcha}
                    onChange={handleChange}
                    className="form-control w-25"
                    placeholder="Captcha"
                  />
                  <button
                    type="submit"
                    disabled={loading}
                    className="btn fw-bold"
                    style={{
                      backgroundColor: "#00BFFF",
                      color: "white",
                      padding: "10px 25px",
                      borderRadius: "6px",
                    }}
                  >
                    {loading ? "Sending..." : "Send Message"}
                  </button>
                </div>
                {success && <p style={{ color: "green", marginTop: "10px" }}>{success}</p>}
                {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}
              </form>
            </Slide>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
